<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="BEPI" id="_idParaDest-2"><span class="CharOverride-1"><a id="page_vii"></a><a id="page_vi"></a></span><a id="page_vi">“We rejoice in our sufferings,</a></p><a id="page_vi">
<p class="BEPI2">knowing that suffering produces</p>
<p class="BEPI2">endurance, endurance produces</p>
<p class="BEPI2">character, and character produces</p>
<p class="BEPI2">hope. And hope does not</p>
<p class="BEPI2">disappoint us.”</p>
<p class="BEPIC">Romans 5:3–5</p>
</a></div><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?676c1e09